import React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

import BreederProfilePastPuppiesCarousel from 'dpl/components/BreederProfile/Show/BreederProfilePastPuppiesCarousel';
import BreederProfilePastPuppiesSectionSkeleton from 'dpl/components/BreederProfile/Show/skeletons/BreederProfilePastPuppiesSectionSkeleton';

import useLitters from '../../hooks/useLitters';

export default function ReservedAndPastPuppiesList() {
  const { breederProfileId } = useSelector(({ server }) => server);

  const { isFetchingLitters, pastPuppies, reservedPuppies } = useLitters({
    limit: 5
  });

  if (isFetchingLitters) {
    return <BreederProfilePastPuppiesSectionSkeleton />;
  }

  if (isEmpty(pastPuppies) && isEmpty(reservedPuppies)) {
    return null;
  }

  return (
    <BreederProfilePastPuppiesCarousel
      breederProfileId={breederProfileId}
      puppies={[...reservedPuppies, ...pastPuppies]}
    />
  );
}
